import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Col, Button } from "antd/es";
import animationData from "../../../../../Animation.json";
import FeedbackModal from "../../../../Feedback/FeedbackModal";
import { useStateValue } from "../../../../../Reducer/reducer";
import axios from "axios";
import { BaseUrl } from "../../../../Constants/Constants";

const CareerMcqDescResult = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [{ UserID }] = useStateValue();
  const [timer, setTimer] = useState(10);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackAvailable, setFeedbackAvailable] = useState(null);

  // Prefetch feedback forms on results page load
  useEffect(() => {
    if (!id) return;
    axios
      .post(
        `${BaseUrl}feedback-form/list_of_feedback_forms`,
        { course_id: id },
        { withCredentials: true }
      )
      .then((res) => {
        const list = Array.isArray(res?.data?.data) ? res.data.data : [];
        setFeedbackAvailable(list.length > 0);
      })
      .catch(() => setFeedbackAvailable(false));
  }, [id]);

  useEffect(() => {
    if (!feedbackAvailable) return;
    if (timer === 0) {
      setShowFeedbackModal(true);
      return;
    }
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [timer, feedbackAvailable]);

  const handleDashboard = () => {
    if (feedbackAvailable) {
      setShowFeedbackModal(true);
    } else {
      navigate(`/`);
    }
  };

  const handleFeedbackSuccess = () => {
    setShowFeedbackModal(false);
    navigate(`/`);
  };
  return (
    <div>
      <Row justify="center" align="middle">
        <Col style={{ textAlign: "center" }}>
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ height: 200, width: 100 }} // Customize the size
          />
          <h2>Your marks will be sent to you via email. </h2>
          {/* TIMER DISPLAY (only when feedback exists) */}
          {!showFeedbackModal && feedbackAvailable && (
            <div
              style={{
                margin: "20px 0",
                fontSize: 24,
                fontWeight: "bold",
                color: "#555",
              }}
            >
              Feedback form in: {timer} second{timer !== 1 ? "s" : ""}
            </div>
          )}
          <Button type="primary" onClick={handleDashboard}>
            Continue to Dashboard
          </Button>
        </Col>
      </Row>

      <FeedbackModal
        visible={showFeedbackModal}
        courseId={id}
        userId={UserID}
        onSuccessRedirect={handleFeedbackSuccess}
      />
    </div>
  );
};

export default CareerMcqDescResult;
